var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "7px",
    height: "12px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -17 -14 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.8797250859106525 5.7234468937875755  C 6.959908361970219 5.803607214428857  7 5.895791583166332  7 6  C 7 6.104208416833666  6.959908361970219 6.196392785571142  6.8797250859106525 6.2765531062124245  L 1.274914089347079 11.879759519038076  C 1.1947308132875143 11.959919839679358  1.102520045819015 12  0.9982817869415808 12  C 0.8940435280641468 12  0.8018327605956472 11.959919839679358  0.7216494845360825 11.879759519038076  L 0.1202749140893471 11.278557114228457  C 0.040091638029782384 11.198396793587174  0 11.1062124248497  0 11.002004008016032  C 0 10.897795591182364  0.040091638029782384 10.80561122244489  0.1202749140893471 10.725450901803608  L 4.847079037800687 6  L 0.1202749140893471 1.2745490981963927  C 0.040091638029782384 1.1943887775551096  0 1.1022044088176348  0 0.9979959919839683  C 0 0.893787575150299  0.040091638029782384 0.8016032064128242  0.1202749140893471 0.7214428857715425  L 0.7216494845360825 0.12024048096192397  C 0.8018327605956472 0.04008016032064088  0.8940435280641468 0  0.9982817869415808 0  C 1.102520045819015 0  1.1947308132875143 0.04008016032064088  1.274914089347079 0.12024048096192397  L 6.8797250859106525 5.7234468937875755  Z ",
    fillRule: "nonzero",
    fill: "#ffffff",
    stroke: "none",
    transform: "matrix(1 0 0 1 17 14 )"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.ed444ad6702de8ebca64e1180ec8b2e0.svg";
export { ForwardRef as ReactComponent };